import useOwners from './useOwners';
import PropertyCombobox from 'components/PropertyCombobox';
import PropertySelector from './PropertySelector';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal';
import CambiarPropietarioModal from './CambiarPropietarioModal';
import EditarPropietarioModal from './EditarPropietarioModal';
import GrupoEncabezado from 'components/GrupoEncabezado';
import { BLOQUE_TIPOS } from 'pages/admin/propiedades/PropertyForm';
import Paginacion from 'components/Paginacion';
import styles from './Owners.module.css';

export default function Owners() {
  const {
    LIMIT, alert, allProperties, cambiando, collapsed, editando, confirmDel, confirmDeleteOwner, delError, deleting,
    fileRef, filterProp, grouped, handleCambiarPropietario, handleEditarPropietario, handleDeleteOwner, handleDownloadReport, handleDownloadTemplate,
    handleFilterProp, handleImport, importBlocked, importProp, importResult, importing,
    isAdminMultiProp, isBlocked, isReadOnly, isSuperAdmin, items, loading, necesitaPropiedad, page,
    propsLoaded, search, setAlert, setCambiando, setEditando, setConfirmDel, setDelError, setFile, setFilterProp, setImportProp,
    setImportPropObj, setImportResult, setPage, setSearch, setSelectedPropObj, setShowPropWarning,
    setSinProp, showPropWarning, sinProp, terminarCambio, terminarEdicion, toggleGroup, total,
  } = useOwners();

  const irAPagina = (n) => { setPage(n); window.scrollTo({ top: 0 }); };
  const Pagination = () => <Paginacion pagina={page} total={total} porPagina={LIMIT} onCambiar={irAPagina} />;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1><i className={`fas fa-users ${styles.iconoTitulo}`} />Propietarios</h1>
          <p>Importa y gestiona los propietarios de las unidades</p>
        </div>
      </div>

      {alert && (
        <div className={`alert alert-${alert.type} ${styles.alertaClic}`} onClick={() => setAlert(null)}>
          {alert.message}
        </div>
      )}

      {/* ── Panel de importación ── */}
      <div className={`card ${styles.tarjetaImport}`}>
        <div className="card-header">
          <div className={styles.tituloImport}>
            <i className={`fas fa-file-excel ${styles.iconoExcel}`} />
            <h2>Importar desde Excel</h2>
          </div>
          <button className="btn btn-sm btn-secondary" onClick={handleDownloadTemplate}>
            <i className="fas fa-download" /> Descargar plantilla
          </button>
        </div>
        <div className={`card-body ${styles.cuerpoImport}`}>

          {/* Selector propiedad para importar — super_admin y admin multi-prop */}
          {(isSuperAdmin || (isAdminMultiProp && allProperties.length > 1)) && (
            <div>
              <label className={`form-label ${styles.etiquetaDestino}`}>
                <i className={`fas fa-building ${styles.iconoDestino}`} />
                Propiedad destino *
              </label>
              <PropertyCombobox
                value={importProp} placeholder="— Selecciona una propiedad —" minWidth={0} maxWidth={9999}
                onChange={(pid, elegida) => {
                  const propObj = elegida || allProperties.find(p => String(p.id) === String(pid)) || null;
                  setImportProp(pid);
                  setImportPropObj(propObj);
                  setShowPropWarning(false);
                }}
              />
              {showPropWarning && !importProp && (
                <div className={styles.avisoPropiedad}>
                  <i className={`fas fa-exclamation-triangle ${styles.avisoPropiedadIcono}`} />
                  <span className={styles.avisoPropiedadTexto}>Debes seleccionar una propiedad antes de importar.</span>
                </div>
              )}
            </div>
          )}

          {/* Bloqueo de importación si membresía bloqueada */}
          {importBlocked && !isSuperAdmin && (
            <div className={styles.bannerBloqueo}>
              <i className={`fas fa-ban ${styles.bannerBloqueoIcono}`} />
              <span><strong>Membresía bloqueada.</strong> No puedes importar propietarios para esta propiedad.</span>
            </div>
          )}

          {/* Archivo + botón */}
          <div className={styles.filaArchivo}>
            <div className={`form-group ${styles.campoArchivo}`}>
              <label className="form-label">Archivo Excel (.xlsx) *</label>
              <input ref={fileRef} type="file" accept=".xlsx,.xls" className={`form-control ${styles.campoExcel}`}
                onChange={e => setFile(e.target.files[0] || null)}
                disabled={(importBlocked || isBlocked) && !isSuperAdmin} />
            </div>
            <button className={`btn btn-primary ${styles.botonImportar}`} onClick={handleImport}
              disabled={importing || ((importBlocked || isBlocked) && !isSuperAdmin)}>
              {importing ? <><i className="fas fa-spinner fa-spin" /> Importando...</> : <><i className="fas fa-upload" /> Importar</>}
            </button>
            <button className={`btn btn-secondary ${styles.botonDescargar}`} onClick={handleDownloadReport}
              disabled={!importResult?.reporte_excel}>
              <i className="fas fa-file-download" /> Descargar resultado
            </button>
          </div>

          <div className={styles.cajaColumnas}>
            {/* #1: las columnas que exige de verdad el importador (routes/owners.js). */}
            {[
              { titulo: 'Columnas requeridas: ', cols: ['nombre','tipo_identificacion','numero_identificacion','email','tipo_bloque','numero_bloque','numero_unidad','property_id'] },
              { titulo: 'Opcionales: ',          cols: ['apellido','telefono','coeficiente'] },
            ].map(g => (
              <div key={g.titulo} className={styles.grupoColumnas}>
                <strong className={styles.tituloColumnas}>{g.titulo}</strong>
                {g.cols.map((col, i, arr) => (
                  <span key={col}>
                    <code className={styles.codigoColumna}>{col}</code>
                    {i < arr.length - 1 ? ' · ' : ''}
                  </span>
                ))}
              </div>
            ))}
            <div className={styles.notaColumnas}>
              <code>tipo_bloque</code> debe ser uno de: {BLOQUE_TIPOS.map(t => t.label).join(', ')}; <code>numero_bloque</code> su número (1, 2…);{' '}
              <code>coeficiente</code> en <strong>fracción decimal</strong> (ej. 0.0125 = 1,25 %), <strong>sin el símbolo %</strong>: no se escribe como porcentaje. Sin coeficiente, la unidad no pesa en el cuórum ni en las votaciones.
            </div>
          </div>
        </div>
      </div>

      {/* ── Resultado importación ── */}
      {importResult && (
        <div className={`card ${styles.tarjetaResultado}`}>
          <div className="card-header">
            <h2><i className={`fas fa-clipboard-check ${styles.iconoResultado}`} />Resultado de importación</h2>
            <button className="btn-close" onClick={() => setImportResult(null)}>✕</button>
          </div>
          <div className={`card-body ${styles.cuerpoResultado}`}>
            {/* #3: coeficientes a medias o que no suman 1 (aviso, no error) */}
            {importResult.avisos_coeficiente?.length > 0 && (
              <div className={`alert alert-warning ${styles.alertaAvisos}`}>
                <i className={`fas fa-triangle-exclamation ${styles.iconoAviso}`} />
                <strong>Revisa los coeficientes:</strong>
                <ul className={styles.listaAvisos}>
                  {importResult.avisos_coeficiente.map((a, i) => <li key={i}>{a}</li>)}
                </ul>
              </div>
            )}
            <div className={styles.resumen}>
              {[
                { label: 'Creados',      count: importResult.created?.length,               color: 'var(--success)', icon: 'fa-plus-circle' },
                { label: 'Actualizados', count: importResult.updated?.length,                color: 'var(--warning)', icon: 'fa-sync' },
                { label: 'Errores',      count: importResult.errors?.length,                 color: '#f04438',        icon: 'fa-exclamation-circle' },
                { label: 'Pendientes',   count: importResult.pendientes_confirmacion?.length, color: '#7c3aed',        icon: 'fa-question-circle' },
              ].map(s => (
                <div key={s.label} className={styles.resumenItem} style={{ '--tono': s.color }}>
                  <i className={`fas ${s.icon} ${styles.resumenIcono}`} />
                  <div>
                    <div className={styles.resumenNumero}>{s.count}</div>
                    <div className={styles.resumenEtiqueta}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
            {importResult.errors?.length > 0 && (
              <div>
                <p className={styles.tituloLista}>Filas con error:</p>
                <div className={styles.listaFilas}>
                  {importResult.errors.map((e, i) => (
                    <div key={i} className={styles.filaMensaje}>
                      <span className={`${styles.etiquetaFila} ${styles.etiquetaError}`}>Fila {e.fila}</span>
                      <span className={styles.mensajeFila}>{e.error}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {importResult.pendientes_confirmacion?.length > 0 && (
              <div className={importResult.errors?.length > 0 ? styles.separado : undefined}>
                <p className={styles.tituloLista}>
                  Filas pendientes de confirmación — la numeración de unidad no coincide con ninguna existente, revisa el reporte descargado y vuelve a cargar el archivo indicando si se debe renombrar o rechazar:
                </p>
                <div className={styles.listaFilas}>
                  {importResult.pendientes_confirmacion.map((p, i) => (
                    <div key={i} className={styles.filaMensaje}>
                      <span className={`${styles.etiquetaFila} ${styles.etiquetaPendiente}`}>Fila {p.fila}</span>
                      <span className={styles.mensajeFila}>{p.mensaje}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Lista de propietarios ── */}
      <div className="card">
        <div className="card-header">
          <div className={styles.listaTitulo}>
            <h2>Lista de propietarios</h2>
            {!necesitaPropiedad && <span className="badge badge-primary">{total}</span>}
          </div>
          <div className={styles.listaControles}>

            {/* Banners de membresía inline */}
            {isBlocked && filterProp && (
              <span className={`${styles.chipEstado} ${styles.chipBloqueada}`}>
                <i className={`fas fa-ban ${styles.chipIcono}`} /> Bloqueada
              </span>
            )}
            {isReadOnly && !isBlocked && filterProp && (
              <span className={`${styles.chipEstado} ${styles.chipSoloLectura}`}>
                <i className={`fas fa-lock ${styles.chipIcono}`} /> Solo lectura
              </span>
            )}

            {/* Selector de propiedad — PropertySelector ya maneja la condición de mostrar */}
            <PropertySelector
              value={filterProp}
              onChange={handleFilterProp}
              onChangeProperty={setSelectedPropObj}
              placeholder="— Selecciona una propiedad —"
            />
            {isSuperAdmin && (
              <button type="button" className={`btn btn-sm ${sinProp ? 'btn-primary' : 'btn-secondary'} ${styles.botonSinPropiedad}`} aria-pressed={sinProp}
                title="Propietarios que ya no tienen ninguna unidad"
                onClick={() => { const v = !sinProp; setSinProp(v); if (v) { setFilterProp(''); setSelectedPropObj(null); } }}>
                <i className="fas fa-user-slash" /> Sin propiedad asignada
              </button>
            )}
            <div className={styles.buscador}>
              <i className={`fas fa-search ${styles.buscadorIcono}`} />
              {/* maxLength = tope del backend (200): por encima responde 422 y la lista no se actualizaría. */}
              <input type="text" className={`form-control ${styles.campoBuscador}`} placeholder="Buscar propietario..." maxLength={200}
                value={search} onChange={e => setSearch(e.target.value)} />
            </div>
          </div>
        </div>

        {necesitaPropiedad ? (
          <div className="empty-state">
            <i className="fas fa-building" />
            <p>Selecciona una propiedad para ver sus propietarios, o escribe en el buscador para buscar en todas.</p>
          </div>
        ) : loading || (isAdminMultiProp && !isSuperAdmin && !propsLoaded) ? <div className="loading"><div className="spinner" /></div> :
          items.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-users" />
              <p>{search ? `Sin resultados para "${search}"` : filterProp ? 'Sin propietarios para esta propiedad' : sinProp ? 'No hay propietarios sin propiedad asignada.' : 'No hay propietarios registrados.'}</p>
            </div>
          ) : isSuperAdmin ? (
            /* ── Vista super_admin: agrupado por propiedad ── */
            <div>
              {grouped.map(group => {
                const isOpen = !collapsed[group.id];
                return (
                  <div key={group.id} className={styles.grupo}>
                    <GrupoEncabezado
                      icono="building"
                      titulo={group.name}
                      cifras={[{ etiqueta: 'Propietarios', valor: group.owners.length }]}
                      abierto={isOpen}
                      onAlternar={() => toggleGroup(group.id)}
                    />
                    {isOpen && (
                      <div className="table-wrapper">
                        <table>
                          <thead>
                            <tr><th>#</th><th>Nombre</th><th>Identificación</th><th>Email</th><th>Teléfono</th><th>Unidad</th><th>Torre</th><th className={styles.thDerecha}>Coeficiente</th><th></th></tr>
                          </thead>
                          <tbody>
                            {group.owners.map(o => (
                              <tr key={`${group.id}-${o.id}`}>
                                <td className={styles.celdaId}>#{o.id}</td>
                                <td><strong>{o.nombre} {o.apellido}</strong></td>
                                <td><span className={styles.tipoDocumento}>{o.tipo_identificacion}</span>{' '}{o.numero_identificacion}</td>
                                <td>{o.email}</td>
                                <td>{o.telefono || '—'}</td>
                                <td>
                                  {o._units.length > 0
                                    ? o._units.map(u => (
                                        <span key={u.id} className={styles.chipUnidad}>
                                          {u.numero_unidad}
                                        </span>
                                      ))
                                    : <span className={styles.sinDato}>—</span>}
                                </td>
                                <td>
                                  {o._units.length > 0
                                    ? o._units.map(u => (
                                        <span key={u.id} className={styles.lineaTorreSola}>
                                          {u.building?.numero_torre || '—'}
                                        </span>
                                      ))
                                    : <span className={styles.sinDato}>—</span>}
                                </td>
                                <td className={styles.celdaCoef}>
                                  {o._units.length > 0
                                    ? o._units.map(u => (
                                        <span key={u.id} className={`${styles.lineaCoef} ${u.coefficiente_votacion > 0 ? styles.coefPositivo : styles.coefCero}`}>
                                          {u.coefficiente_votacion > 0 ? Number(u.coefficiente_votacion).toFixed(4) : '—'}
                                        </span>
                                      ))
                                    : '—'}
                                </td>
                                <td className={styles.celdaCentro}>
                                  {group.id !== 'sin-propiedad' && (
                                    <>
                                      <button className="btn btn-sm btn-secondary btn-icon" title="Editar los datos de esta persona"
                                        disabled={(isBlocked || isReadOnly) && !isSuperAdmin}
                                        onClick={() => handleEditarPropietario(o)}>
                                        <i className="fas fa-pen" />
                                      </button>
{o._units.length > 0 && (
                                      <button className="btn btn-sm btn-secondary btn-icon" title="Cambiar propietario de una unidad (venta)"
                                        disabled={(isBlocked || isReadOnly) && !isSuperAdmin}
                                        onClick={() => handleCambiarPropietario(o, o._units)}>
                                        <i className="fas fa-right-left" />
                                      </button>
                                    )}
                                    <button className="btn btn-sm btn-danger btn-icon" title={`Quitar de ${group.name}`}
                                      onClick={() => handleDeleteOwner(o, group)}>
                                      <i className="fas fa-user-slash" />
                                    </button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            /* ── Vista admin: tabla simple (con agrupación si tiene filtro) ── */
            <>
              {filterProp && grouped.length > 0 ? (
                /* Admin multi-prop con filtro: vista agrupada */
                grouped.map(group => {
                  const isOpen = !collapsed[group.id];
                  return (
                    <div key={group.id} className={styles.grupo}>
                      <GrupoEncabezado
                        icono="building"
                        titulo={group.name}
                        cifras={[{ etiqueta: 'Propietarios', valor: group.owners.length }]}
                        abierto={isOpen}
                        onAlternar={() => toggleGroup(group.id)}
                      />
                      {isOpen && (
                        <div className="table-wrapper">
                          <table>
                            <thead>
                              <tr><th>#</th><th>Nombre</th><th>Identificación</th><th>Email</th><th>Teléfono</th><th>Unidad</th><th>Torre</th><th className={styles.thDerecha}>Coeficiente</th><th></th></tr>
                            </thead>
                            <tbody>
                              {group.owners.map(o => (
                                <tr key={`${group.id}-${o.id}`}>
                                  <td className={styles.celdaId}>#{o.id}</td>
                                  <td><strong>{o.nombre} {o.apellido}</strong></td>
                                  <td><span className={styles.tipoDocumento}>{o.tipo_identificacion}</span>{' '}{o.numero_identificacion}</td>
                                  <td>{o.email}</td>
                                  <td>{o.telefono || '—'}</td>
                                  <td>
                                    {o._units.length > 0
                                      ? o._units.map(u => (
                                          <span key={u.id} className={styles.chipUnidad}>
                                            {u.numero_unidad}
                                          </span>
                                        ))
                                      : <span className={styles.sinDato}>—</span>}
                                  </td>
                                  <td className={styles.celdaTorre}>
                                    {o._units.length > 0
                                      ? o._units.map(u => (
                                          <span key={u.id} className={styles.lineaTorre}>{u.building?.numero_torre || '—'}</span>
                                        ))
                                      : '—'}
                                  </td>
                                  <td className={styles.celdaCoef}>
                                    {o._units.length > 0
                                      ? o._units.map(u => (
                                          <span key={u.id} className={`${styles.lineaCoef} ${u.coefficiente_votacion > 0 ? styles.coefPositivo : styles.coefCero}`}>
                                            {u.coefficiente_votacion > 0 ? Number(u.coefficiente_votacion).toFixed(4) : '—'}
                                          </span>
                                        ))
                                      : '—'}
                                  </td>
                                  <td className={styles.celdaCentro}>
                                    {group.id !== 'sin-propiedad' && (
                                      <>
                                        <button className="btn btn-sm btn-secondary btn-icon" title="Editar los datos de esta persona"
                                          disabled={(isBlocked || isReadOnly) && !isSuperAdmin}
                                          onClick={() => handleEditarPropietario(o)}>
                                          <i className="fas fa-pen" />
                                        </button>
{o._units.length > 0 && (
                                        <button className="btn btn-sm btn-secondary btn-icon" title="Cambiar propietario de una unidad (venta)"
                                          disabled={(isBlocked || isReadOnly) && !isSuperAdmin}
                                          onClick={() => handleCambiarPropietario(o, o._units)}>
                                          <i className="fas fa-right-left" />
                                        </button>
                                      )}
                                      <button className="btn btn-sm btn-danger btn-icon" title={`Quitar de ${group.name}`}
                                        onClick={() => handleDeleteOwner(o, group)}>
                                        <i className="fas fa-user-slash" />
                                      </button>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                /* Admin con 1 propiedad o sin filtro: tabla simple */
                <div className="table-wrapper">
                  <table>
                    <thead>
                      <tr><th>#</th><th>Nombre</th><th>Identificación</th><th>Email</th><th>Teléfono</th><th>Unidad</th><th>Torre</th><th className={styles.thDerecha}>Coeficiente</th></tr>
                    </thead>
                    <tbody>
                      {items.map(o => (
                        <tr key={o.id}>
                          <td className={styles.celdaId}>#{o.id}</td>
                          <td><strong>{o.nombre} {o.apellido}</strong></td>
                          <td><span className={styles.tipoDocumento}>{o.tipo_identificacion}</span> {o.numero_identificacion}</td>
                          <td>{o.email}</td>
                          <td>{o.telefono || '—'}</td>
                          <td>
                            {(o.units || []).length > 0
                              ? (o.units || []).map(u => (
                                  <span key={u.id} className={styles.chipUnidad}>
                                    {u.numero_unidad}
                                  </span>
                                ))
                              : <span className={styles.sinDato}>—</span>}
                          </td>
                          <td className={styles.celdaTorre}>
                            {(o.units || []).length > 0
                                      ? (o.units || []).map(u => (
                                          <span key={u.id} className={styles.lineaTorre}>{u.building?.numero_torre || '—'}</span>
                                        ))
                                      : '—'}
                          </td>
                          <td className={styles.celdaCoef}>
                            {(o.units || []).length > 0
                              ? (o.units || []).map(u => (
                                  <span key={u.id} className={`${styles.lineaCoef} ${u.coefficiente_votacion > 0 ? styles.coefPositivo : styles.coefCero}`}>
                                    {u.coefficiente_votacion > 0 ? Number(u.coefficiente_votacion).toFixed(4) : '—'}
                                  </span>
                                ))
                              : '—'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )
        }
      </div>
      {!loading && !necesitaPropiedad && <Pagination />}

      {editando && (
        <EditarPropietarioModal owner={editando} onClose={() => setEditando(null)} onDone={terminarEdicion} />
      )}

      {cambiando && (
        <CambiarPropietarioModal owner={cambiando.owner} unidades={cambiando.unidades}
          onClose={() => setCambiando(null)} onDone={terminarCambio} />
      )}

      {confirmDel && (
        <ConfirmDeleteModal title="Quitar propietario" onClose={() => { setConfirmDel(null); setDelError(''); }} onConfirm={confirmDeleteOwner} deleting={deleting} error={delError}>
          <div className={styles.quitarPregunta}>
            ¿Quitar a <span className={styles.quitarNombre}>{`${confirmDel.owner.nombre} ${confirmDel.owner.apellido}`.trim()}</span> de "{confirmDel.group.name}"?
          </div>
          <div className={styles.quitarDetalle}>
            Si no le quedan unidades asignadas en ninguna otra propiedad, su cuenta de acceso al sistema quedará desactivada hasta que se le asigne una unidad nuevamente.
          </div>
        </ConfirmDeleteModal>
      )}
    </div>
  );
}
